// extracted by mini-css-extract-plugin
module.exports = {"datePicker":"patient-results_datePicker__1Q8kO"};